module.exports = __webpack_public_path__ + "./static/img/join.b7165bd0fe333732fa3bec118300e6e4.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/join.png
// module id = ./client/src/assets/fontawesome/join.png
// module chunks = 0